import Card from '@/components/atoms/Card';
import LinkButton from '@/components/atoms/LinkButton';
import RichTextFieldStrapi from '@/components/atoms/RichTextField/RichTextFieldStrapi';
import { Text } from '@/components/atoms/Text';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { cn } from '@/lib/utils';
import iconArrowRightSrc from '~/icons/arrow-right.svg';
import quoteIconSrc from '~/svg/IconQuote.svg';
import { Testimonial } from '../Testimonials';
import { SvgIcon } from '@/components/SvgIcon';

type Props = {
  testimonial: Testimonial;
};

const TestimonialContent = ({ testimonial }: Props) => {
  const { texts } = useTranslation();

  return (
    <Card
      classNames={{
        root: cn(
          'flex-1 bg-brand-50 border-none',
          'lg:p-10 lg:pl-8',
          'flex-col flex justify-between'
        ),
      }}
    >
      <div className='mt-3 flex-col flex gap-y-3 text-left'>
        <SvgIcon src={quoteIconSrc} className='h-6 w-6' />
        <Text classNames={{ wrapper: 'font-serif' }} variant='h3'>
          {testimonial.testimonial.header}
        </Text>
        <RichTextFieldStrapi
          block={testimonial.testimonial.description}
          classNames={{ paragraph: 'text-body-l text-gray-950' }}
        />
      </div>
      <div
        className={cn(
          'w-full flex justify-between ',
          'lg:flex-row lg:items-end',
          'flex-col items-start',
          'mt-12 lg:mt-0'
        )}
      >
        <div className='flex flex-col gap-y-1 text-left'>
          <Text variant='body-l-medium'>
            {testimonial.testimonial.authorName}
          </Text>
          <Text variant='body-l'>{testimonial.testimonial.authorRole}</Text>
        </div>
        {testimonial.testimonial.caseStudyUrl && (
          <LinkButton
            variant='outlined'
            color='secondary'
            rightSection={<SvgIcon src={iconArrowRightSrc} className='h-3' />}
            href={testimonial.testimonial.caseStudyUrl || ''}
            classNames={{
              root: cn('w-full mt-8 lg:mt-0 lg:w-auto text-gray-950'),
            }}
          >
            {texts.testimonials.readCaseStudy}
          </LinkButton>
        )}
      </div>
    </Card>
  );
};

export default TestimonialContent;
